import { create } from "zustand";
import { UserStoreProps } from "../types/user.type";

const userStore = create<UserStoreProps>((set) => ({
  loading: true,
  user: undefined,
  setUser: (newUser) => set((state) => ({
    ...state,
    loading: false,
    user: newUser
  }))
}))

export default userStore